var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "400"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-icon', [_vm._v("mdi-eye")]), _vm._v(" Visualizar Turno ")], 1)]), _c('div', {
    staticClass: "container dialog"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-7"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Turno",
      "outlined": "",
      "dense": "",
      "readonly": "",
      "maxlength": "25"
    },
    model: {
      value: _vm.content.descricao,
      callback: function ($$v) {
        _vm.$set(_vm.content, "descricao", $$v);
      },
      expression: "content.descricao"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '##:##',
      expression: "'##:##'"
    }],
    attrs: {
      "label": "Hora de Início",
      "outlined": "",
      "dense": "",
      "readonly": ""
    },
    model: {
      value: _vm.content.horaInicio,
      callback: function ($$v) {
        _vm.$set(_vm.content, "horaInicio", $$v);
      },
      expression: "content.horaInicio"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '##:##',
      expression: "'##:##'"
    }],
    attrs: {
      "label": "Hora de Término",
      "outlined": "",
      "dense": "",
      "readonly": ""
    },
    model: {
      value: _vm.content.horaFim,
      callback: function ($$v) {
        _vm.$set(_vm.content, "horaFim", $$v);
      },
      expression: "content.horaFim"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "btn-group text-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('onClose');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")]), _vm._v(" Fechar ")], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }